import * as Yup from "yup";
// import moment from "moment";
// const today = moment(new Date()).format("DD-MM-YYYY");
// console.log("today", new Date());

export const validationAddProgramSchema = Yup.object().shape({
  name: Yup.string().required("Program Name Is Required."),
  total_users_limit: Yup.number()
    .required("Limit Of Students Is Required.")
    .nullable()
    .positive("the number should be positive."),
  start_date: Yup.date()
    .required("Start Date Is Required.")
    .nullable()
    .min(
      new Date(),
      "Please select a start date that is today or later."
    ),
  end_date: Yup.date()
    .required("End Date Is Required.")
    .nullable()
    .min(
      Yup.ref("start_date"),
      "End date must be later than start date."
    )
});

export const validationEditProgramSchema = ({ initialStartDate }) =>
  Yup.object().shape({
    name: Yup.string().required("Program Name is required."),

    total_users_limit: Yup.number()
      .required("Limit of students is required.")
      .nullable()
      .positive("The number should be positive."),

    start_date: Yup.date()
      .required("Start date is required.")
      .test(
        "start-date-changed",
        "If changed, start date must be today or later.",
        function (value) {
          if (!value) return true;

          const current = new Date(value);
          current.setHours(0, 0, 0, 0); // Remove time portion

          const initial = initialStartDate
            ? new Date(initialStartDate)
            : null;
          if (initial) initial.setHours(0, 0, 0, 0);

          return current.getTime() >= initial.getTime();
        }
      ),
    end_date: Yup.date()
      .required("End date is required.")
      .test(
        "end-date-changed",
        "If changed, End date must be After start date and today.",
        function (value) {
          if (!value) return true;
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const currentEndDate = new Date(value);
          currentEndDate.setHours(0, 0, 0, 0); // Remove time portion

          const initialSt = initialStartDate
            ? new Date(initialStartDate)
            : null;
          if (initialSt) initialSt.setHours(0, 0, 0, 0);

          return (
            currentEndDate.getTime() >= today.getTime() &&
            currentEndDate.getTime() > initialSt.getTime()
          );
        }
      )
  });
